import { render, staticRenderFns } from "./RegulatoryUpdateVerifyPassword.vue?vue&type=template&id=8af3a7bc&scoped=true"
import script from "./RegulatoryUpdateVerifyPassword.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateVerifyPassword.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateVerifyPassword.vue?vue&type=style&index=0&id=8af3a7bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af3a7bc",
  null
  
)

export default component.exports